import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/api";
import { translations } from "@/i18n";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = guest, obj = user
  const [lang, setLang] = useState(localStorage.getItem("lang") || "TR");
  const [cart, setCart] = useState([]);

  const t = (key) => translations[lang][key] || key;

  const toggleLang = () => {
    const next = lang === "TR" ? "ENG" : "TR";
    setLang(next);
    localStorage.setItem("lang", next);
  };

  const refreshUser = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  };

  const refreshCart = async () => {
    try {
      const { data } = await api.get("/cart");
      setCart(data.items || []);
    } catch {
      setCart([]);
    }
  };

  useEffect(() => {
    (async () => {
      const u = await refreshUser();
      if (u) refreshCart();
    })();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!sessionStorage.getItem("ps_visited")) {
      sessionStorage.setItem("ps_visited", "1");
      api.post("/track/visit").catch(() => {});
    }
  }, []);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(false);
    setCart([]);
  };

  return (
    <AppContext.Provider
      value={{ user, setUser, lang, toggleLang, t, cart, setCart, refreshCart, refreshUser, logout }}
    >
      {children}
    </AppContext.Provider>
  );
}
